import { isRouteErrorResponse, useRouteError, Link as RouterLink } from 'react-router-dom';

// material-ui
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// ==============================|| ELEMENT ERROR - COMMON ||============================== //

export default function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            404 - Page not found
          </Alert>
          <Typography variant="body1" sx={{ mb: 2 }}>
            The page you are looking for does not exist or you may have followed a bad link.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button component={RouterLink} to="/login" variant="outlined">
              Go to Login
            </Button>
            <Button component={RouterLink} to="/bookings" variant="contained">
              Go to Bookings
            </Button>
          </Stack>
        </Box>
      );
    }

    if (error.status === 401) {
      return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Alert severity="error">401 - You are not authorized to view this page.</Alert>
          <Button component={RouterLink} to="/login" sx={{ mt: 2 }} variant="contained">
            Login
          </Button>
        </Box>
      );
    }

    if (error.status === 503) {
      return <Alert severity="error">503 - Looks like our API is down. Please try again later.</Alert>;
    }

    if (error.status === 418) {
      return <Alert severity="error">418 - I'm a teapot. Contact administrator.</Alert>;
    }
  }

  // Non-route errors (JS errors etc)
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        Unexpected error occurred.
      </Alert>
      <Button component={RouterLink} to="/login" variant="contained">
        Return to Login
      </Button>
    </Box>
  );
}
